import { render, staticRenderFns } from "./RenewContract.vue?vue&type=template&id=1a58b8d2&"
import script from "./RenewContract.vue?vue&type=script&lang=js&"
export * from "./RenewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RenewContract.vue"
export default component.exports